// ホームトップイメージ内ヘッドライン調整
$(function() {
  $('#shopify-section-1480352639511 h2.slideshow__title').html('<h2 class="slideshow__title"><span>「一期一会」</span>Make Happy With Tea</h2>');
});
// End: ホームトップイメージ内ヘッドライン調整

